import * as React from 'react';
import { graphql, ChildProps } from 'react-apollo';
import gql from 'graphql-tag';
import APIRequest from '../api_request';
import { trackInteraction, LISTING_TYPE } from '@reverbdotcom/commons/dist/tracker';
import BumpModal from './bump_modal';
import ProductPageBump from './product_page_bump';
import { CoreBumpListing } from '../../schemas/rql';

interface AdminBidPropType {
  bid: number;
  expiresAt?: string;
}

interface ExternalProps {
  listingId: string;
  listingSoldWithBump: boolean;

  // in the near future these could be hardcoded here instead of coming from core
  bidTiers: Array<string>[];
  tierIncrement: number;

  // these need to come from core for now
  bid: number;
  adminBid?: AdminBidPropType;
  impressions?: number;
  salesCount?: number;
  salesSpent?: string;
  salesRevenue?: string;
}

type Props = ChildProps<ExternalProps, CoreBumpListing.Query>;

interface State {
  bid: number;
  selectedBid: number;
  error: boolean;
  didBidChange: boolean;
  deleted: boolean;
  showMobileSlider: boolean;
}

export class BumpDisplay extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      bid: this.props.bid,
      selectedBid: this.props.bid,
      error: false,
      didBidChange: false,
      deleted: false,
      showMobileSlider: false,
    };

    this.toggleSlider = this.toggleSlider.bind(this);
    this.updateBid = this.updateBid.bind(this);
    this.handleBidChange = this.handleBidChange.bind(this);
    this.changeDismiss = this.changeDismiss.bind(this);
  }

  trackInteraction(newBid) {
    trackInteraction({
      componentName: 'ProductPageBump',
      type: LISTING_TYPE,
      entityId: this.props.listingId,
      context: { bumpPercentage: newBid },
    });
  }

  get displayBumpBanner() {
    return this.isLive && !this.props.listingSoldWithBump;
  }

  get displayBumpModal() {
    if (
      this.listing?.bumpEligible

    ) { return false; }

    return this.isDraft;
  }

  get listing() {
    return this.props.data?.listing;
  }

  get isNewCondition(): boolean {
    return this.listing?.condition?.conditionSlug === 'brand-new';
  }

  get isLive(): boolean {
    return this.listing?.state === 'live';
  }

  get isDraft(): boolean {
    return this.listing?.state === 'draft';
  }

  setBid(newBid) {
    APIRequest.V3.post('/bump/bids/', {
      bump_bids: {
        product_id: this.props.listingId,
        bid: newBid,
      },
    })
      .then(() => {
        this.setState({
          bid: newBid, selectedBid: newBid, error: false, didBidChange: true, deleted: false,
        });
      })
      .fail(() => this.setState({ error: true, selectedBid: this.state.bid }));
  }

  deleteBid() {
    APIRequest.V3.destroy(`/bump/bids/${this.props.listingId}`)
      .then(() => {
        this.setState({
          bid: null, selectedBid: null, error: false, deleted: true, didBidChange: true,
        });
      })
      .fail(() => {
        this.setState({ error: true, selectedBid: this.state.bid });
      });
  }

  updateBid(newBid) {
    this.trackInteraction(newBid);
    if (newBid === 0.0) {
      this.deleteBid();
    } else {
      this.setBid(newBid);
    }
  }

  toggleSlider() {
    this.setState({ showMobileSlider: !this.state.showMobileSlider });
  }

  handleBidChange(newBid) {
    this.setState({ selectedBid: newBid });
  }

  changeDismiss() {
    this.setState({ didBidChange: false });
  }

  productPageBump() {
    return (
      <ProductPageBump
        sliderToggle={this.toggleSlider}
        productId={this.props.listingId}
        updateBid={this.updateBid}
        changeDismiss={this.changeDismiss}
        showMobileSlider={this.state.showMobileSlider}
        selectedBid={this.state.selectedBid}
        deleted={this.state.deleted}
        onBidChange={this.handleBidChange}
        didBidChange={this.state.didBidChange}
        bid={this.state.bid}
        adminBid={this.props.adminBid}
        bidTiers={this.props.bidTiers}
        tierIncrement={this.props.tierIncrement}
        listingPrice={this.listing.sellerPrice}
        shippingPrice={this.listing.shipping?.shippingPrices[0]?.originalRate}
        impressions={this.props.impressions}
        salesCount={this.props.salesCount}
        salesSpent={this.props.salesSpent}
        salesRevenue={this.props.salesRevenue}
        isNewCondition={this.isNewCondition}
        error={this.state.error}
      />
    );
  }

  renderBumpBanner() {
    return this.productPageBump();
  }

  renderBumpModal() {
    return (
      <BumpModal modalOpen>
        {this.productPageBump()}
      </BumpModal>
    );
  }

  render() {
    if (!this.listing) return null;

    return (
      <div>
        {this.displayBumpModal && this.renderBumpModal()}
        {this.displayBumpBanner && this.renderBumpBanner()}
      </div>
    );
  }
}

export const CoreBumpListingCardFragment = gql`
  fragment CoreBumpListingCard on Listing {
    _id
    id
    bumpEligible
    state
    condition {
      conditionSlug
    }
    csp {
      id
    }
    sellerPrice {
      amount
      amountCents
      currency
      display
    }
    shipping {
      shippingPrices {
        originalRate {
          amount
          amountCents
          currency
          display
        }
      }
    }
  }
`;

const withQuery = graphql<ExternalProps, CoreBumpListing.Query>(
  gql`
    query Core_Bump_Listing(
      $id: String
    ){
      listing(
        input: {id: $id}
      ) {
        ...CoreBumpListingCard
      }
    }
    ${CoreBumpListingCardFragment}
  `,
  {
    options: (ownProps) => {
      return {
        errorPolicy: 'all',
        variables: {
          id: ownProps.listingId,
        },
      };
    },
  },
);

export default withQuery(BumpDisplay);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/bump_display.tsx